(function() { window.GUID_59d5063d_2d66_4da6_a23f_bbb6dcb08bfe = { getGuid: function() { return "59d5063d-2d66-4da6-a23f-bbb6dcb08bfe"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        class DropDown extends Controls.Base.RefreshOnChange {
            HasChanged() {
                let valA = this.StartValue;
                let valB = this.GetSelectedItemValue();
                if ((valA == null || valB == null) && valB != valA) {
                    return true;
                }
                let hasChanged = false;
                $.each(valA, (key, value) => {
                    if (valB[key] != value) {
                        hasChanged = true;
                        return;
                    }
                });
                return hasChanged;
            }
            UpdateStartValue() {
                this.StartValue = this.GetSelectedItemValue();
            }
            ClearStartValue() {
                this.StartValue = null;
            }
            InputNames() {
                let array = [];
                let data = {};
                this.FillHasChangedValuesInData(data);
                array.push(this.Name);
                return array;
            }
            get IsOpen() {
                return this.isOpen;
            }
            set IsOpen(value) {
                this.isOpen = value;
                if (value) {
                    this.$DropDown.addClass("IsOpen");
                }
                else {
                    this.$DropDown.removeClass("IsOpen");
                }
            }
            constructor(id) {
                super();
                this.searchBoxTextIn = false;
                let me = this;
                me.Id = id;
                me.$DropDown = $("#" + id);
                me.BindSelectorElements();
                me.$SlideDownPanel = $("#" + me.$DropDown.data("listkey"));
                me.$Items = me.$SlideDownPanel.find(".Item");
                me.BindSlideDownPanelElements();
                me.AppendSlideDownPanelToEndOfBodyIfNot();
                me.IncrementDecrementOwnerOfSlideDownPanel();
                me.BindBodyEvents();
                me.RefreshOnElementValueChange(() => {
                    me.Refresh();
                });
                me.StartValue = me.GetValue(me.$SelectedItem);
            }
            BindBodyEvents() {
                let me = this;
                if (CompuSport.DOM == undefined) {
                    return;
                }
                //CompuSport.DOM.win.resize(function () {
                //    if (me.IsOpen) {
                //        //me.HideList();
                //    }
                //});
                CompuSport.DOM.body.on("hidedropdowns", function (e, caller) {
                    if (caller == undefined || caller != me) {
                        me.HideList();
                    }
                });
                CompuSport.DOM.body.off("mousedown.dropdown");
                CompuSport.DOM.body.on("mousedown.dropdown", function (e) {
                    var clickedDropDown = $(e.target).closest(".CSDropDown,.DropDownSlideDownPanel");
                    if (clickedDropDown.length == 0) {
                        CompuSport.DOM.body.trigger("hidedropdowns");
                    }
                });
                me.bindSearchBox();
            }
            BindSelectorElements() {
                let me = this;
                me.Name = me.$DropDown.data("name");
                me.$DropDown.data("context", me);
                me.AutoSaveOnPost = me.$DropDown.data("autosaveonpost") == "True";
                me.$SlideDownPanel = $("#" + me.$DropDown.data("listkey"));
                me.$Hiddens = me.$DropDown.find("input[type=hidden]");
                me.$Displays = me.$DropDown.find(".dispval");
                me.ExtractElementIdsFromData(me.$DropDown);
                me.BindDropDownSelectorEvents();
            }
            BindDropDownSelectorEvents() {
                let me = this;
                me.$DropDown
                    .on("click", function (e) {
                    me.ToggleListVisibility();
                })
                    .on("remove", function (e) {
                    me.RemoveSlideDownPanelIfPossible();
                });
            }
            IncrementDecrementOwnerOfSlideDownPanel(decrement = false) {
                let me = this;
                let direction = decrement ? -1 : 1;
                let ownercounttitle = "ownercount";
                let actualCount = me.$SlideDownPanel.data(ownercounttitle);
                if (actualCount == null) {
                    actualCount = 0;
                }
                actualCount = actualCount + direction;
                me.$SlideDownPanel.data(ownercounttitle, actualCount);
                return actualCount;
            }
            AppendSlideDownPanelToEndOfBodyIfNot() {
                let me = this;
                var parent = me.$SlideDownPanel.parent();
                if (parent.hasClass("IsNotAtTheEndOfBody")) {
                    if (CompuSport.DOM != undefined) {
                        me.$SlideDownPanel.appendTo(CompuSport.DOM.body);
                    }
                    parent.remove();
                }
            }
            RemoveSlideDownPanelIfPossible() {
                let me = this;
                let remainingOwner = me.IncrementDecrementOwnerOfSlideDownPanel(true);
                if (remainingOwner == 0) {
                    me.$SlideDownPanel.remove();
                }
            }
            AjustLayoutOfTheList() {
                let me = this;
                let layoutHelperClass = CompuSport.Layout.PositionTargetRefToSourceAndWindows(me.$DropDown, me.$SlideDownPanel);
                me.$SlideDownPanel.removeClass(CompuSport.Layout.AllLayoutHelperClasses());
                me.$SlideDownPanel.addClass(layoutHelperClass);
                me.$ListContent.css("min-width", me.$DropDown.outerWidth() + "px");
                me.$ControlPanel.css("min-width", me.$DropDown.width()); /*Vue ca position est de type fixed, je dois setter la taille dememe au lieu de 100%*/
                me.$ControlPanel.css("width", me.$SlideDownPanel.width() - 5);
            }
            ToggleListVisibility() {
                if (this.IsOpen) {
                    this.HideList();
                }
                else {
                    this.ShowList();
                }
            }
            ShowList() {
                let me = this;
                if (me.$DropDown.hasClass("IsReadOnly")) {
                    return;
                }
                CompuSport.DOM.body.trigger("hidedropdowns", me);
                CompuSport.DOM.body.trigger("beforeshowing", me);
                me.AjustLayoutOfTheList();
                me.$SlideDownPanel.on("click.item", ".Item", function (e) {
                    var clickedItem = $(e.target);
                    var tr = clickedItem.closest("tr");
                    me.SelectItem(tr);
                    if (me.StayOpenUntilNextClick) {
                        me.StayOpenUntilNextClick = false;
                    }
                    else {
                        me.HideList();
                    }
                });
                me.bindSearchBox();
                if (me.$SelectedItem && !me.$SelectedItem.hasClass("Empty")) {
                    me.$SelectedItem.addClass("IsSelected");
                }
                me.$SlideDownPanel.slideDown(100, function () {
                    me.$SearchBox.focus();
                    me.$SearchBox.select();
                    let controlPanelHeight = me.$ControlPanel.height();
                    if (controlPanelHeight == undefined) {
                        controlPanelHeight = 0;
                    }
                    me.$ListPart.css("margin-top", controlPanelHeight + "px");
                    let $hideBorderTweak = $(".HideBorderTweak", me.$SlideDownPanel);
                    $hideBorderTweak.css("min-width", me.$DropDown.width());
                    if (me.$SelectedItem != null && me.$SelectedItem.length > 0) {
                        me.$SlideDownPanel.scrollTo(me.$SelectedItem, 0, true, -(controlPanelHeight + 5));
                    }
                    else {
                        me.$SlideDownPanel.scrollTop(0);
                    }
                });
                me.IsOpen = true;
            }
            bindSearchBox() {
                let me = this;
                me.$SearchBox = me.$SlideDownPanel.find(".SearchBox");
                me.$SearchBoxContainer = me.$SearchBox.parent();
                me.$SearchBox.offon("keydown." + me.Id, function (e) {
                    let key = window.event ? e.keyCode : e.which;
                    if (!me.searchBoxTextIn) {
                        me.$SearchBoxContainer.addClass("textin");
                        me.searchBoxTextIn = true;
                    }
                    if (key == 13) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                });
                me.$SearchBox.offon("keyup." + me.Id, function (e) {
                    let key = window.event ? e.keyCode : e.which;
                    if (key == 13) {
                        let firstNotHidden = me.$Items.filter(":not(.Hidden)").first();
                        if (firstNotHidden.length > 0) {
                            me.SelectItem(firstNotHidden);
                            me.HideList();
                        }
                        return;
                    }
                    let currentText = me.$SearchBox.val().toLowerCase();
                    CompuSport.Lag(350, function () {
                        if (currentText.trim() == "") {
                            me.$Items.removeClass("Hidden");
                        }
                        else {
                            $.each(me.$Items, function () {
                                let item = $(this);
                                let cells = item.children("td");
                                let content = cells.text().toLowerCase();
                                if (content.indexOf(currentText) > -1) {
                                    item.removeClass("Hidden");
                                }
                                else {
                                    item.addClass("Hidden");
                                }
                            });
                        }
                        me.AjustLayoutOfTheList();
                    });
                });
            }
            HideList() {
                let me = this;
                if (me.IsOpen) {
                    if (me.$SelectedItem) {
                        me.$SelectedItem.removeClass("IsSelected"); /*Evite que si la liste est partagé entre plusieurs drop down, que l'item
                                                                  selectionné dun autre dropdown semble l'etre dans cette liste*/
                    }
                    me.$SlideDownPanel.off("click.item");
                    me.$SearchBox.off("keydown.dropdown");
                    me.$SearchBox.off("keyup.dropdown");
                    CompuSport.DOM.body.trigger("beforehiding", me);
                    me.$SlideDownPanel.slideUp(100, function () {
                        if (me.$SearchBox.length > 0) {
                            me.$SearchBox.val("");
                            me.searchBoxTextIn = false;
                            me.$SearchBoxContainer.removeClass("textin");
                            me.$Items.removeClass("Hidden");
                        }
                    });
                    me.IsOpen = false;
                }
            }
            //private AppendHiddenHasChanged() {
            //    let me = this;
            //    if (me.AutoSaveOnPost && (me.$HasChanged == undefined || me.$HasChanged.length == 0)) {
            //        me.$HasChanged = $("<input name='" + me.Name + ".HasChanged' value='true' type='hidden'/>");
            //        me.$HasChanged.insertAfter(me.$DropDown);
            //    }
            //}
            ClearSelection() {
                let me = this;
                me.$LastSelectedItem = me.$SelectedItem;
                if (me.$SelectedItem != null) {
                    me.$SelectedItem.removeClass("IsSelected");
                }
                me.$SelectedItem = null;
                me.$DropDown.addClass("IsEmpty");
                if (me.SelectionChange != undefined) {
                    me.SelectionChange(me);
                }
                me.$DropDown.trigger("change", me);
            }
            SelectItem(item) {
                let me = this;
                me.$LastSelectedItem = me.$SelectedItem;
                //me.AppendHiddenHasChanged();
                me.$DropDown.parent(".InputRow").addClass("IsEdited");
                if (me.$SelectedItem != null) {
                    me.$SelectedItem.removeClass("IsSelected");
                }
                me.$SelectedItem = item;
                me.$SelectedItem.addClass("IsSelected");
                let isEmptyItem = me.$SelectedItem.hasClass("Empty");
                if (isEmptyItem) {
                    me.$DropDown.addClass("IsEmpty");
                    me.$SelectedItem.removeClass("IsSelected");
                }
                else {
                    me.$DropDown.removeClass("IsEmpty");
                }
                $.each(me.$Hiddens, function () {
                    let $hidden = $(this);
                    let modelValue = me.GetValue(item, $hidden.data("name"));
                    $hidden.val(modelValue);
                    if (modelValue != null) {
                        if ($hidden.data("followedbyvalue") != null) {
                            let $hiddenContainer = $hidden.parent();
                            let contents = $hiddenContainer.contents();
                            let hiddenIndex = null;
                            $.each(contents, function (i) {
                                if (this.tagName == "INPUT") {
                                    hiddenIndex = i;
                                    return;
                                }
                            });
                            if (hiddenIndex != null) {
                                contents[hiddenIndex + 1].nodeValue = modelValue;
                            }
                        }
                    }
                });
                $.each(me.$Displays, function () {
                    let $disp = $(this);
                    let modelValue = me.GetValue(item, $disp.data("name"));
                    $disp.html(modelValue);
                });
                if (me.SelectionChange != undefined) {
                    me.SelectionChange(me);
                }
                me.$DropDown.trigger("change", me);
            }
            AlterHiddenNameToNotBePosted($hidden) {
                $hidden.attr("name", "_hidden_" + $hidden.attr("name").replace("_hidden_", ""));
            }
            AlterHiddenNameToBePosted($hidden) {
                $hidden.attr("name", $hidden.attr("name").replace("_hidden_", ""));
            }
            GetSelectedItemValue(propertyName) {
                return this.GetValue(this.$SelectedItem, propertyName);
            }
            GetValueFromHiddens() {
                let me = this;
                var data = {};
                $.each(me.$Hiddens, function () {
                    var $this = $(this);
                    var name = $this.data("name").toLowerCase();
                    var val = $this.val();
                    data[name] = val;
                });
                return data;
            }
            GetValue(item, propertyName) {
                let me = this;
                if (!item || item.hasClass("Empty") || item.length == 0) {
                    return null;
                }
                var modelValues = item.data("m");
                let isOldDropDown = false;
                if (propertyName == me.Id) {
                    isOldDropDown = true;
                }
                let end = modelValues.length;
                var dynamicModel = {};
                for (var i = 0; i < end; i++) {
                    let modelValue = modelValues[i];
                    if (isOldDropDown) {
                        if (modelValue.n == "Value") {
                            return modelValue.v;
                        }
                    }
                    dynamicModel[modelValue.n.toLowerCase()] = modelValue.v;
                }
                if (propertyName == null) {
                    return dynamicModel;
                }
                else {
                    propertyName = propertyName.toLowerCase();
                    return dynamicModel[propertyName];
                }
            }
            SetValue(value) {
                let me = this;
                var rows = this.$ListPart.find("tr.Item");
                var filteredValue = rows.filter(function () {
                    let itemValue = me.GetValue($(this));
                    if (itemValue == null) {
                        return value == null;
                    }
                    for (var name in value) {
                        if (itemValue[name] != value[name]) {
                            return false;
                        }
                    }
                    return true;
                });
                if (filteredValue.length > 0) {
                    me.SelectItem(filteredValue.first());
                }
                else if (value != null) {
                    me.SetValue(null);
                }
            }
            CallSelectionChange() {
                let me = this;
                if (me.SelectionChange != undefined) {
                    me.SelectionChange(me);
                }
            }
            Refresh(callback, extraData) {
                let me = this;
                var data = CompuSport.Send.PrepareData(me);
                try {
                    if (extraData != null) {
                        for (var key in extraData) {
                            data[key] = extraData[key];
                        }
                    }
                }
                catch (error) {
                    console.log("Error while adding extra data to the data object");
                }
                CompuSport.Ajax.Get(this.$SlideDownPanel.data("refreshurl"), data, function (response) {
                    var $response = $("<div>" + response + "</div>");
                    let est = $response.find(".SearchBox");
                    me.ReplaceCurrentDropDownWithNewOne($response);
                    if (callback) {
                        callback();
                    }
                });
            }
            PrepareDataToSend(data) {
                let me = this;
                me.FillHasChangedValuesInData(data);
                if (me.HasChanged()) {
                    data[me.Name + ".HasChanged"] = true;
                }
            }
            FillHasChangedValuesInData(data) {
                var me = this;
                var modelValues = me.$SelectedItem.data("m");
                if (modelValues != null) {
                    data[me.Name] = modelValues[0].v;
                }
                else {
                    data[me.Name] = null;
                }
                $.each(modelValues, function () {
                    var val = this;
                    data[me.Name + "." + val.n] = val.v;
                    if (val.n == "Value") {
                        data[me.Name] = val.v;
                    }
                });
                return data;
            }
            ReplaceCurrentDropDownWithNewOne(dropDown) {
                let me = this;
                var val = me.GetValueFromHiddens();
                var newSelector = dropDown.find(".CSDropDown");
                var newSlideDown = dropDown.find(".DropDownSlideDownPanel");
                if (newSelector.length == 1) {
                    me.$DropDown.off("click").off("remove");
                    me.$DropDown.attr("class", newSelector.attr("class"));
                    me.$DropDown.html(newSelector.html());
                    me.BindSelectorElements();
                }
                if (newSlideDown.length == 1) {
                    me.$SlideDownPanel.html(newSlideDown.html());
                    me.BindSlideDownPanelElements();
                }
                me.SetValue(val);
                me.$DropDown.trigger("refreshed", me);
            }
            ReplaceCurrentDropDownPanelWithNewOne(newPanel) {
                let me = this;
                if (newPanel.length == 1) {
                    me.$SlideDownPanel.html(newPanel.html());
                    me.BindSlideDownPanelElements();
                }
            }
            BindSlideDownPanelElements() {
                let me = this;
                me.$ListPart = me.$SlideDownPanel.find(".ListPart");
                me.$ListContent = me.$SlideDownPanel.find(".Content");
                me.$ControlPanel = me.$SlideDownPanel.find(".ControlPanel");
                me.$SelectedItem = $(".IsSelected", me.$ListPart);
                me.$EmptyItem = $(".Empty td", me.$ListPart);
                me.$Items = me.$SlideDownPanel.find(".Item");
            }
        }
        Controls.DropDown = DropDown;
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=DropDown.js.map
